const _env = function(name) {
  return typeof window !== "undefined" && typeof window["_envs"] !== "undefined"
    ? window?._envs?.[name]
    : process.env[name];
};

export default _env;